import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({

  root: {
    textAlign: 'left',
    '& tr:last-child > td': {
      borderBottom: 'none'
    }
  },

  title: {
    textTransform: 'capitalize',
    '& > .MuiChip-root': {
      fontWeight: '500',
      marginLeft: '8px'
    }
  },

  head: {
    background: theme.palette.primary.main,
    '& *': {
      color: 'white',
    }
  },
  truncate: {
    overflow: 'hidden', 
    textOverflow: 'ellipsis', 
    whiteSpace: 'nowrap', 
    maxWidth: 180
  }


}))